export default __webpack_public_path__ + "static/media/Level-Creation-Template1.71944eb5.xlsx";